import {css} from "@panda/css";

import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {useGetOfferDetailQuery} from "../../../offer/api/get_offer_detail";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    isPropertyApplication: boolean;
    offerId?: number;
    price: number | null;
}

export const PreferencesFormWithPriceHeader = ({isPropertyApplication, offerId, price}: IProps) => {
    const {data: offerDetail} = useGetOfferDetailQuery(offerId!, {skip: !offerId});

    const priceText = isPropertyApplication ? "Cena mieszkania:" : "Ceny od:";
    const currency = offerDetail?.currency || Currency.PLN;

    return (
        <div className={containerStyle}>
            <BrandHandclapIcon size="4.4" wrapperSize="4.4" wrapperColor="var(--colors-primary)" />
            <div className={textSectionStyle}>
                <Text variant="headline_3">Konto założone!</Text>
                <Text variant="body_copy_2">Wszystkie ceny na portalu są już dostępne!</Text>
            </div>
            {price && (
                <div className={priceStyle}>
                    <Text variant="headline_6">{priceText}</Text>
                    <Text variant="body_copy_0" strong>
                        <Highlight>{priceFormat(price, {unit: getCurrency({currency})})}</Highlight>
                    </Text>
                </div>
            )}
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    borderBottom: "1px solid var(--colors-gray-400)",
    pb: 3,
    gap: 2
});

const textSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: 0.5
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2,
    p: 1,
    gap: 1,
    width: "100%",

    sm: {
        flexDirection: "column",
        alignItems: "flex-start",
        width: "auto"
    }
});
import {css} from "@panda/css";

import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {useGetOfferDetailQuery} from "../../../offer/api/get_offer_detail";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    isPropertyApplication: boolean;
    offerId?: number;
    price: number | null;
}

export const PreferencesFormWithPriceHeader = ({isPropertyApplication, offerId, price}: IProps) => {
    const {data: offerDetail} = useGetOfferDetailQuery(offerId!, {skip: !offerId});

    const priceText = isPropertyApplication ? "Cena mieszkania:" : "Ceny od:";
    const currency = offerDetail?.currency || Currency.PLN;

    return (
        <div className={containerStyle}>
            <BrandHandclapIcon size="4.4" wrapperSize="4.4" wrapperColor="var(--colors-primary)" />
            <div className={textSectionStyle}>
                <Text variant="headline_3">Konto założone!</Text>
                <Text variant="body_copy_2">Wszystkie ceny na portalu są już dostępne!</Text>
            </div>
            {price && (
                <div className={priceStyle}>
                    <Text variant="headline_6">{priceText}</Text>
                    <Text variant="body_copy_0" strong>
                        <Highlight>{priceFormat(price, {unit: getCurrency({currency})})}</Highlight>
                    </Text>
                </div>
            )}
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    borderBottom: "1px solid var(--colors-gray-400)",
    pb: 3,
    gap: 2
});

const textSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: 0.5
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2,
    p: 1,
    gap: 1,
    width: "100%",

    sm: {
        flexDirection: "column",
        alignItems: "flex-start",
        width: "auto"
    }
});
